import React, { useState, useEffect, useContext } from 'react';
import { CChartLine } from '@coreui/react-chartjs';
import {
  CButton,
  CButtonGroup,
  CButtonToolbar,
  CCard,
  CCardBody,
  CCardTitle,
  CCol,
  CRow,
} from '@coreui/react';
import { FirebaseContext } from '../../firebase';
import { getStyle, hexToRgba } from '@coreui/utils';

const brandPrimary = getStyle('--primary');
const brandSuccess = getStyle('--success');
const brandInfo = '#0080FF'; // Fallback color;
const brandWarning = getStyle('--warning');
const brandDanger = getStyle('--danger');

const Snapshot = () => (
  <div>
    <SnapshotForm />
  </div>
);

const SnapshotBase = (props) => {
  const [users, setUsers] = useState([]);
  const [date, setDate] = useState(new Date().toISOString());
  const [radioSelected, setRadioSelected] = useState(1);
  const firebase = useContext(FirebaseContext);

  useEffect(() => {
    const fetchData = () => {
      // Uncomment and modify Firebase calls according to your structure.
      // firebase.firestore().collection('calories').where('userid', '==', props.authUser.uid).get().then((snapshot) => {
      //   const usersList = snapshot.docs.map(doc => ({ ...doc.data(), uid: doc.id }));
      //   setUsers(usersList);
      // });
    };

    fetchData();
    const timerID = setInterval(() => tick(), 5000);

    return () => {
      clearInterval(timerID);
    };
  }, [firebase]);

  const tick = () => {
    setDate(new Date().toISOString());
  };

  const usersSampleData = [
    { date: '2024-07-01', calories: 500 },
    { date: '2024-07-02', calories: 450 },
    { date: '2024-07-03', calories: 600 },
    { date: '2024-07-04', calories: 700 },
    { date: '2024-07-05', calories: 400 },
    { date: '2024-07-06', calories: 550 },
    { date: '2024-07-07', calories: 650 },
  ];

  const labels = usersSampleData.map(user => user.date);
  const dataVals = usersSampleData.map(user => user.calories);

  const mainChart = {
    labels: labels,
    datasets: [
      {
        label: 'Calories',
        backgroundColor: hexToRgba(brandInfo, 10),
        borderColor: brandInfo,
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: dataVals,
      },
    ],
  };

  const mainChartOpts = {
    tooltips: {
      enabled: true,
      intersect: true,
      mode: 'index',
      position: 'nearest',
      callbacks: {
        labelColor: function (tooltipItem, chart) {
          return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor };
        },
      },
    },
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  const onRadioBtnClick = (selected) => {
    setRadioSelected(selected);
  };

  return (
    <div>
      <CRow>
        <CCol>
          <CCard>
            <CCardBody>
              <CRow>
                <CCol sm="5">
                  <CCardTitle className="mb-0">Snapshot</CCardTitle>
                  <div className="small mb-2">Last refreshed: {date}</div>
                </CCol>
                <CCol sm="7" className="d-none d-sm-inline-block">
                  <CButton color="primary" className="float-right"><i className="icon-cloud-download"></i></CButton>
                  <CButtonToolbar className="float-right" aria-label="Toolbar with button groups">
                    <CButtonGroup className="mr-3" aria-label="First group">
                      <CButton color="outline-secondary" onClick={() => onRadioBtnClick(1)} active={radioSelected === 1}>Day</CButton>
                      <CButton color="outline-secondary" onClick={() => onRadioBtnClick(2)} active={radioSelected === 2}>Month</CButton>
                      <CButton color="outline-secondary" onClick={() => onRadioBtnClick(3)} active={radioSelected === 3}>Year</CButton>
                    </CButtonGroup>
                  </CButtonToolbar>
                </CCol>
              </CRow>
              <div className="chart-wrapper" style={{ height: 300 + 'px', marginTop: 40 + 'px' }}>
                <CChartLine data={mainChart} options={mainChartOpts} height={300} />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  );
};

const SnapshotForm = SnapshotBase;

export default Snapshot;
export { SnapshotForm };


